<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSend_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path fill="currentColor" d="M3 20v-6l8-2-8-2V4l19 8-19 8Z" />
</svg>
